module.exports = __webpack_public_path__ + "img/main_story_slide7.91766bb8.jpg";